import { moveToWebview } from './moveToWebview';
import { moveToToday } from './moveToToday';
import { moveToSearch } from './moveToSearch';
import { moveToScreens } from './moveToScreens';
import { moveToHome } from './moveToHome';
import { moveToLikeFolders } from './moveToLikeFolders';
import { moveToRoot } from './moveToRoot';

export const useCommonNavigator = () => {
  return {
    moveToRoot,
    moveToWebview,
    moveToToday,
    moveToSearch,
    moveToScreens,
    moveToHome,
    moveToLikeFolders,
  };
};
